var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopmodalIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.208 7.273H7.792C5.506 7.273 5.455 8.5 5.455 10c0 1.5.051 2.727 2.337 2.727h24.416c2.285 0 2.337-1.227 2.337-2.727 0-1.5-.052-2.727-2.337-2.727z",
    fill: "#4F4F4F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.208 15.921H7.792c-2.286 0-2.338 1.228-2.338 2.728 0 1.5.052 2.727 2.338 2.727h24.416c2.285 0 2.337-1.227 2.337-2.727 0-1.5-.052-2.728-2.337-2.728z",
    fill: "#4F4F4F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.208 24.57H7.792c-2.286 0-2.338 1.227-2.338 2.727 0 1.5.052 2.728 2.338 2.728h24.416c2.285 0 2.337-1.228 2.337-2.728 0-1.5-.052-2.727-2.337-2.727z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.455,
    y: 7.273,
    width: 18.182,
    height: 5.455,
    rx: 1.818,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.454,
    y: 15.921,
    width: 29.066,
    height: 5.455,
    rx: 1.818,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.454,
    y: 24.57,
    width: 25.454,
    height: 5.455,
    rx: 1.818,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopmodalIcon4);
export default __webpack_public_path__ + "static/media/stopmodal-icon4.d36d4e77caff7659a562724107a6b1d0.svg";
export { ForwardRef as ReactComponent };